import React from "react";
import { useHistory } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import ContentContainer from "../../templates/content-container/contentContainer";
import XGSErrorMessage from "../../ui-components/error-message/errorMessage";
import Tag from "../../ui-components/molecules/tag/tag";
import { PAGE_IDS } from "../../app/data/common/pageIds";
import { QUERY_KEYS } from "../../app/data/common/queryKeys";
import releaseDetailsService from "../../app/data/release-details/releaseDetailsService";
import { Routes } from "../../app/route/RoutesConfig";
import { audienceLabel, formatDay, formatTimestamp, statusColor, statusLabel } from "./releaseDetailsDisplay";
import "./releaseDetails.scss";

const ReleaseDetailsList: React.FC = () => {
  const history = useHistory();
  const listQuery = useQuery({
    queryKey: [QUERY_KEYS.RELEASE_DETAILS],
    queryFn: () => releaseDetailsService.list()
  });

  return (
    <ContentContainer
      pageId={PAGE_IDS.RELEASE_DETAILS}
      title="Release Details"
      isLoading={listQuery.isLoading}
    >
      <div className="xgs-release-details">
        <p className="xgs-release-details__intro">
          Instructions and user guides posted with announcements.
        </p>
        {listQuery.isError && (
          <XGSErrorMessage>{(listQuery.error as Error)?.message || "Unable to load release details"}</XGSErrorMessage>
        )}
        {listQuery.data && listQuery.data.length === 0 && (
          <div className="xgs-release-details__empty">No release details have been posted.</div>
        )}
        <div className="xgs-release-details__list">
          {(listQuery.data || []).map((item) => {
            const period = [formatDay(item.from), formatDay(item.to)].filter(Boolean).join(" – ");
            const audience = audienceLabel(item.recipientType);
            const posted = formatTimestamp(item.dateCreated);
            return (
              <button
                type="button"
                className="xgs-release-details__card"
                key={item.id}
                onClick={() => history.push(`${Routes.releaseDetails}/${item.id}`)}
              >
                <div className="xgs-release-details__card-main">
                  <div className="xgs-release-details__card-title">{item.header}</div>
                  <div className="xgs-release-details__meta">
                    {posted && <span>Created {posted}</span>}
                    {audience && <span>{audience}</span>}
                    {period && <span>{period}</span>}
                  </div>
                </div>
                <div className="xgs-release-details__card-side">
                  {item.status && (
                    <Tag mods={{ color: statusColor(item.status) }}>{statusLabel(item.status)}</Tag>
                  )}
                  <span className="xgs-release-details__card-open">View</span>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </ContentContainer>
  );
};

export default ReleaseDetailsList;
